import React, { useState, useCallback } from 'react';
import { Mic, Send } from 'lucide-react';

/**
 * SpinozaInput — single-line text input, Enter to send.
 * Mic icon placeholder (not functional).
 */
const SpinozaInput = ({ onSend, onFocusChange, disabled = false }) => {
  const [value, setValue] = useState('');

  const handleSubmit = useCallback(
    (e) => {
      e.preventDefault();
      const trimmed = value.trim();
      if (!trimmed) return;
      onFocusChange?.(false);
      onSend(trimmed);
      setValue('');
    },
    [value, onSend],
  );

  return (
    <form onSubmit={handleSubmit} className="flex items-center gap-1 border border-zinc-300 bg-white">
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onFocus={() => onFocusChange?.(true)}
        onBlur={() => onFocusChange?.(false)}
        placeholder="Ask Spinoza..."
        disabled={disabled}
        className="flex-1 px-3 py-2 text-xs font-mono text-black bg-transparent focus:outline-none placeholder:text-zinc-400"
      />
      <button
        type="button"
        className="p-2 text-zinc-400 hover:text-zinc-600 transition-colors"
        aria-label="Voice input (coming soon)"
        disabled
      >
        <Mic className="w-3.5 h-3.5" />
      </button>
      <button
        type="submit"
        className="p-2 text-zinc-500 hover:text-[#3832e3] transition-colors"
        disabled={disabled || !value.trim()}
        aria-label="Send"
      >
        <Send className="w-3.5 h-3.5" />
      </button>
    </form>
  );
};

export default SpinozaInput;
